export default __webpack_public_path__ + "static/media/Path 67.3165ee65.svg";